import React, { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { Redirect } from 'react-router';
import { CircularProgress } from '@material-ui/core';
import { useLocation } from 'react-router';
import Styled from '../StyledComponents';
import { useQueryHelper } from '../../../../libs/hooks';
import Template from './template';
import {
  InstagramAnalyticsStoryDetails,
  InstagramAnalyticsStoryDetailsVariables
} from './__generated__/InstagramAnalyticsStoryDetails';
import * as INSTAGRAM_ANALYTICS_STORY_DETAILS from './InstagramAnalyticsStoryDetails.graphql';

interface AnayticsStoryPostDetailProps {
  closeModal: () => void;
  accountId: number;
}

const AnayticsStoryPostDetail = (props: AnayticsStoryPostDetailProps) => {
  const { closeModal, accountId } = props;
  const { t, history, enqueueSnackbar } = useQueryHelper();
  const { search, pathname } = useLocation();

  const storyId = Number(new URLSearchParams(search).get('popup'));

  const { data, loading, error } = useQuery<InstagramAnalyticsStoryDetails, InstagramAnalyticsStoryDetailsVariables>(
    INSTAGRAM_ANALYTICS_STORY_DETAILS,
    {
      variables: { storyId, accountId },
      fetchPolicy: 'cache-and-network',
      onError: useCallback(() => {
        history.push(pathname);
        enqueueSnackbar(t('Post was not found'), { variant: 'error' });
      }, [])
    }
  );

  if (loading) {
    return <CircularProgress size={64} thickness={2.4} color="inherit" />;
  }

  if (error) {
    return <Redirect to="/404" />;
  }

  return (
    <Styled.PostDetailWrapper>
      <Template closeModal={closeModal} data={data} />
    </Styled.PostDetailWrapper>
  );
};

export default AnayticsStoryPostDetail;
